import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import moment from 'moment';

import BobLoadingMask from '../../../components/BobLoadingMask';
import BobModal from '../../../components/BobModal';
import SensorDataTimestampFilter from '../../../containers/Modals/SensorDataTimestampFilter';

import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';

import { getTimeZoneAbbr } from '../../../helpers/timezones';

import * as WeatherActions from '../../../actions/weatherActions';

import classes from '../CreateEntityModal.module.css';
import aClasses from './PreviewWeatherDataModal.module.css';

const PreviewWeatherDataModal = ({
    site,
    bobLoading,
    fetchPreviewWeatherData,
    onClose,
    setWeatherData,
    weatherData,
    ...props
}) => {
    const [startTimestamp, setStartTimestamp] = useState(new moment().subtract(4, 'h'));
    const [endTimestamp, setEndTimestamp] = useState(new moment());
    const [dataState, setDataState] = useState({ sort: [] });

    useEffect(() => {
        const init = async () => {
            await fetchPreviewWeatherData({ endTimestamp: endTimestamp.format(), siteId: site.id, startTimestamp: startTimestamp.format() });
        };

        init();
    }, [startTimestamp, endTimestamp]);

    useEffect(() => {
        return () => {
            setWeatherData([]);
        };
    }, []);

    const renderTimestamp = props => {
        const zone = moment.tz.guess();
        return (
            <td>
                <div>{moment(props.dataItem.timestamp).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(props.dataItemtimestamp), zone)}</div>
            </td>
        );
    };

    const handleFilterChange = (filterName, value) => {
        if (value) {
            if (filterName === 'startTimestamp') {
                let start = value.local();
                if (moment(start).isSameOrAfter(moment(endTimestamp))) {
                    start = moment(endTimestamp).subtract(1, 'h');
                }
                if (moment(endTimestamp).local().diff(start, 'minutes') < 60) {
                    if (moment(start).isAfter(moment().local()) || moment(endTimestamp).add(10080).local().isAfter(moment().local())) {
                        start = moment().local().subtract(1, 'h');
                        const end = moment().local();
                        setEndTimestamp(end);
                    }
                    else {
                        start = moment(endTimestamp).local().subtract(1, 'h');
                    }
                }
                else if (moment(endTimestamp).local().diff(start, 'minutes') > 10080) {
                    const end = moment(start).add(10080, 'm').local();
                    setEndTimestamp(end);
                }
                setStartTimestamp(start);

            }
            else {
                let tempEnd = value.local();
                if (moment(tempEnd).isAfter(moment().local())) {
                    tempEnd = moment().local();
                }
                setEndTimestamp(tempEnd);
                if (moment(tempEnd).local().diff(startTimestamp, 'minutes') > 10080) {
                    const start = moment(tempEnd).subtract(10080, 'm').local();
                    setStartTimestamp(start);
                }
            }
        }
    };

    const renderRowLabel = dataItem => {
        switch (dataItem.field) {
            case 'temp':
                return <td>{`${dataItem.dataItem.temp} (°F)`}</td>;
            case 'humidity':
                return <td>{`${dataItem.dataItem.humidity} (%)`}</td>;
            case 'pressure':
                return <td>{`${dataItem.dataItem.pressure} (hPa)`}</td>;
            case 'tempMin':
                return <td>{`${dataItem.dataItem.tempMin} (°F)`}</td>;
            case 'tempMax':
                return <td>{`${dataItem.dataItem.tempMax} (°F)`}</td>;
            default:
                return '';
        }
    };

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };

    return (
        <BobModal
            title={'Preview Weather Data'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => onClose()}
        >
            <React.Fragment>
                <div>
                    <SensorDataTimestampFilter
                        endTimestamp={endTimestamp}
                        onFilterChange={handleFilterChange}
                        startTimestamp={startTimestamp}
                    />
                </div>
                <div className={aClasses.Table}>
                    <Grid
                        className={aClasses.KendoGrid}
                        sortable={{
                            mode: 'multiple'
                        }}
                        onDataStateChange={onDataStateChange}
                        {...dataState}
                        data={kendoProcess(weatherData, dataState)}
                    >
                        {
                            bobLoading.includes('PreviewWeatherData') ?
                                <GridNoRecords>
                                    Loading weather data
                                </GridNoRecords>
                                :
                                null
                        }
                        <GridColumn
                            title={'TimeStamp'}
                            field={'timestamp'}
                            width={250}
                            cell={renderTimestamp}
                        />
                        <GridColumn
                            title={'Temperature'}
                            field={'temp'}
                            width={150}
                            cell={renderRowLabel}
                        />
                        <GridColumn
                            title={'Humidity'}
                            field={'humidity'}
                            width={120}
                            cell={renderRowLabel}
                        />
                        <GridColumn
                            title={'Pressure'}
                            field={'pressure'}
                            width={120}
                            cell={renderRowLabel}
                        />
                        <GridColumn
                            title={'Min Temp'}
                            field={'tempMin'}
                            width={120}
                            cell={renderRowLabel}
                        />
                        <GridColumn
                            title={'Max Temp'}
                            field={'tempMax'}
                            width={120}
                            cell={renderRowLabel}
                        />
                    </Grid>
                </div>
                {bobLoading.includes('PreviewWeatherData') ?
                    <BobLoadingMask />
                    : null
                }
            </React.Fragment>
        </BobModal>
    );
};

export const mapStateToProps = ({ sensorData, ...state }) => ({
    activeNavSite: state.bob.activeNavSite,
    bobLoading:    state.bob.bobLoading,
    weatherData:   state.weather.weatherData
});

const mapDispatchToProps = {
    ...WeatherActions
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewWeatherDataModal);
